import { useTranslate } from "@similarweb/i18n-provider";

import ManagementCardFilterTag from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardFilterTag";
import type { CardType } from "app/pages/sales-intelligence/modules/manage-integrations/constants/cardTypes";
import { CARD_TYPE_LABEL_KEY } from "app/pages/sales-intelligence/modules/manage-integrations/constants/cardTypes";

interface IProps {
    types: readonly CardType[];
}

const CardTypeChips = ({ types }: IProps): React.ReactElement => {
    const { translate } = useTranslate();

    return (
        <>
            {types.map((type) => (
                <ManagementCardFilterTag key={type}>{translate(CARD_TYPE_LABEL_KEY[type])}</ManagementCardFilterTag>
            ))}
        </>
    );
};

export default CardTypeChips;
